/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { makeWebSocketServiceRequest } from '../utils/request';
import { validateSession } from './test';
import {
  doWebSocketServiceHost,
  whiteLabelEnabled,
} from '../constants/AppConstants';
import { errorLogger } from '../utils/trackingUtil';

// eslint-disable-next-line consistent-return
export const fetchTestSettings = ({ assessmentType, assessmentId }) => {
  if (whiteLabelEnabled) {
    validateSession()
      .then(resp => {
        const sessionId = resp.headers['x-sessionid'];
        const url = `${doWebSocketServiceHost}/fetchsettings/${assessmentType}/${assessmentId}`;
        const config = {
          withCredentials: true,
          headers: {
            'x-sessionid': sessionId,
          },
        };
        return axios.post(url, null, config);
      })
      .catch(error => {
        errorLogger(error);
        return Promise.reject(error);
      });
  } else {
    return makeWebSocketServiceRequest(
      'post',
      `/fetchsettings/${assessmentType}/${assessmentId}`
    );
  }
};

export const getActiveSession = async ({
  id: testId,
  slug: testSlug,
  username,
}) => {
  return makeWebSocketServiceRequest(
    'get',
    `/get-session/${testId}/${testSlug}/${username}`
  );
};
